(() => {
  if (window.__augArticleAssistTrackingInitialized) return;
  window.__augArticleAssistTrackingInitialized = true;

  const STORAGE_KEY = 'aug:article-product-assist:v1';
  const TTL_MS = 30 * 60 * 1000;

  const publishEvent = (eventName, payload) => {
    try {
      if (!window.Shopify?.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
      Promise.resolve(window.Shopify.analytics.publish(`aug_${eventName}`, payload)).catch(() => {});
    } catch (_error) {}
  };

  const readAssist = () => {
    try {
      const assist = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!assist || !assist.ts || Date.now() - assist.ts > TTL_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return assist;
    } catch (_error) {
      return null;
    }
  };

  const writeAssist = (assist) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(assist));
    } catch (_error) {}
  };

  const getProductHandle = (path) => {
    const marker = '/products/';
    const markerIndex = path.indexOf(marker);
    if (markerIndex < 0) return '';
    const handle = path.slice(markerIndex + marker.length).split('/')[0];
    try {
      return decodeURIComponent(handle).slice(0, 100);
    } catch (_error) {
      return handle.slice(0, 100);
    }
  };

  const getCurrentProductHandle = () => {
    const productContext = document.querySelector('[data-product-handle]');
    return productContext?.dataset.productHandle || getProductHandle(window.location.pathname);
  };

  const getAssistPayload = (assist) => ({
    article_handle: assist.article_handle,
    blog_handle: assist.blog_handle,
    article_path: assist.article_path,
    product_handle: assist.product_handle,
    link_context: assist.link_context,
  });

  const articleRoot = document.querySelector('[data-aug-article-assist]');
  if (articleRoot) {
    articleRoot.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const link = target?.closest('a[href]');
      if (!link || !articleRoot.contains(link)) return;

      let destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (_error) {
        return;
      }

      if (destination.origin !== window.location.origin) return;
      const productHandle = getProductHandle(destination.pathname);
      if (!productHandle) return;

      const assist = {
        ts: Date.now(),
        article_handle: (articleRoot.dataset.augArticleHandle || '').slice(0, 100),
        blog_handle: (articleRoot.dataset.augBlogHandle || '').slice(0, 100),
        article_path: window.location.pathname.slice(0, 200),
        product_handle: productHandle,
        link_context: link.classList.contains('aug-colcard') ? 'product_card' : 'inline_link',
      };

      writeAssist(assist);
      publishEvent('article_product_click', getAssistPayload(assist));
    });
    return;
  }

  const currentProductHandle = getCurrentProductHandle();
  if (!currentProductHandle) return;

  const assist = readAssist();
  if (!assist || assist.product_handle !== currentProductHandle) return;

  if (!assist.viewed_at) {
    assist.viewed_at = Date.now();
    writeAssist(assist);
    publishEvent('article_product_view', {
      ...getAssistPayload(assist),
      assist_age_seconds: Math.max(0, Math.round((assist.viewed_at - assist.ts) / 1000)),
    });
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;

      const activeAssist = readAssist();
      if (!activeAssist || activeAssist.product_handle !== currentProductHandle) return;

      const variantField = form.elements.namedItem('id');
      const quantityField = form.elements.namedItem('quantity');
      publishEvent('article_assisted_add_to_cart', {
        ...getAssistPayload(activeAssist),
        variant_id: variantField && 'value' in variantField ? String(variantField.value).slice(0, 40) : '',
        quantity: quantityField && 'value' in quantityField ? String(quantityField.value).slice(0, 10) : '1',
      });
    },
    true
  );
})();


/* AUG AC-93 route v2: context only. No cart, order, page content, or existing tracker mutation. */
(function () {
  'use strict';
  var ARTICLE = '/blogs/column/tire-wax-water-vs-oil-guide';
  var PRODUCT = '/products/tire-leather-wax-1l';
  if (window.location.hostname !== 'augjapan.com' || window.location.pathname !== ARTICLE) return;
  if (window.__augAc93RouteContextV2) return;
  var root = document.querySelector('[data-aug-article-assist]');
  if (!root) return;
  window.__augAc93RouteContextV2 = true;
  var seenPublished = false;
  var seenPending = false;
  var contextEpoch = 0;
  var qaCampaigns = [
    'tire_route_preview_20261026', 'tire_route_release_20261026',
    'ac93_measurement_preview_20261027', 'ac93_measurement_release_20261027'
  ];
  function allowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  }
  function trafficClass() {
    try {
      var q = new URL(window.location.href).searchParams;
      return q.get('utm_source') === 'aug_internal_test' && q.get('utm_medium') === 'qa' &&
        qaCampaigns.indexOf(q.get('utm_campaign')) !== -1 ? 'known_internal_qa' : 'unclassified';
    } catch (_) { return 'unclassified'; }
  }
  function payload(position) {
    return { route_key: 'tire_ac93_v2', measurement_version: 'v2', article_path: ARTICLE,
      product_id: '6883188277424', variant_id: '40646215008432',
      link_position: position || 'unknown', traffic_class: trafficClass() };
  }
  function publish(name, position) {
    if (!allowed()) return Promise.resolve(false);
    try {
      if (!window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return Promise.resolve(false);
      return Promise.resolve(window.Shopify.analytics.publish(name, payload(position))).then(function () { return true; }, function () { return false; });
    } catch (_) { return Promise.resolve(false); }
  }
  function articleSeen() {
    if (seenPublished || seenPending || !allowed()) return;
    var epoch = contextEpoch;
    seenPending = true;
    publish('aug_ac93_route_article_seen', 'unknown').then(function (sent) {
      if (epoch !== contextEpoch) return;
      seenPending = false;
      if (sent && allowed()) seenPublished = true;
    });
  }
  root.addEventListener('click', function (event) {
    try {
      var target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      var link = target && target.closest('a[href]');
      if (!link || !root.contains(link) || !allowed()) return;
      var destination = new URL(link.href, window.location.href);
      if (destination.protocol !== 'https:' || destination.origin !== window.location.origin || destination.pathname !== PRODUCT) return;
      var position = link.closest('[data-aug-tire-route="after-safety"]') ? 'after_safety' :
        (link.closest('.aug-tire-card') ? 'bottom_card' : 'unknown');
      articleSeen();
      // Intentionally no preventDefault, navigation delay, form/fetch interception, or cart mutation.
      publish('aug_ac93_route_link_clicked', position);
    } catch (_) {}
  });
  document.addEventListener('visitorConsentCollected', function () {
    contextEpoch += 1;
    seenPending = false;
    if (!allowed()) { seenPublished = false; return; }
    articleSeen();
  });
  if (window.Shopify && window.Shopify.customerPrivacy) articleSeen();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
        if (!error) articleSeen();
      });
    } catch (_) {}
  }
})();
